<template>
  <div class="content">
    <Form :model="formData" :label-width="150">
      <FormItem label="坐席队列">
        <Input v-model="formData.queue_id" :disabled="!isEdit" style="width: 420px"></Input>
      </FormItem>
      <FormItem label="转接超时时长">
        <InputNumber v-model="formData.transfer_timeout" :min="0" :disabled="!isEdit" style="width: 200px"/><span style="margin-left: 5px">s</span>
      </FormItem>
      <FormItem label="隐藏对话内容">
        <i-switch v-model="formData.hide_conversation_content" :disabled="!isEdit"/>
      </FormItem>
      <FormItem label="关闭坐席识别">
        <i-switch v-model="formData.disable_agent_asr" :disabled="!isEdit"/>
      </FormItem>
      <FormItem label="关闭用户识别">
        <i-switch v-model="formData.disable_user_asr" :disabled="!isEdit"/>
      </FormItem>
      <FormItem>
        <Button type="primary" v-show="!isEdit" @click="openEdit">编辑</Button>
        <Button type="primary" v-show="isEdit" @click="save">保存</Button>
        <Button style="margin-left: 8px" v-show="isEdit" @click="cancel">取消</Button>
      </FormItem>
    </Form>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      isEdit: false,
      formData: {
        queue_id: '',                 //坐席队列 
        transfer_timeout: 0, //转接超时时长 单位秒
        hide_bot_conversation_content: false,
        disable_agent_asr: false,
        disable_user_asr: false,
      },
    }
  },
	computed: {
    ...mapState('setting', ['transfer']),
	},
  watch: {
    transfer: {
      immediate: true,
      handler(val) {
        this.resetForm()
      }
    }
  },
  methods: {
    ...mapActions('setting', ['updateTransfer']),
    openEdit() {
      this.isEdit = true;
    },
    cancel() {
      this.isEdit = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = { ...this.transfer }
    },
    save() {
      this.updateTransfer(this.formData);
      this.isEdit = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
}
</style>
